export default function Error() {
    return <div className="w-screen min-h-screen flex flex-1 items-center justify-center">
        <h3>Máy chủ đang bảo trì hoặc bị lỗi</h3>
    </div>
}